const initialState = {
  pairCode: null,
  userId: null,
  isSaved: false,
  status: null
};

export default initialState;
